export default __webpack_public_path__ + "static/media/Unlimited Morph Grim Blade.fa7810db.jpg";